import React, { useState, useEffect } from 'react';
import { ref, onValue, push, remove, set } from 'firebase/database';
import { database } from '../firebase';
import './AdminPanel.css';

const IMGBB_API_KEY = '88f16d298c527a7bd899cd7fcb518203';
const DEFAULT_SERVICE_AREAS = ['Yıldırım Mah', 'Kocatepe Mah', 'Kartaltepe Mah', 'Muratpaşa Mah'];

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState('products');
  
  // Ürünler
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({ title: '', description: '', image: null });
  const [uploadingProduct, setUploadingProduct] = useState(false);
  
  // Hizmetler
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({ title: '', description: '', image: null });
  const [uploadingService, setUploadingService] = useState(false);
  
  // Müşteri Yorumları
  const [testimonials, setTestimonials] = useState([]);
  const [newTestimonial, setNewTestimonial] = useState({ name: '', company: '', comment: '', rating: 5 });

  // İletişim Bilgileri
  const [contactInfo, setContactInfo] = useState({
    phone: '0540 304 14 14',
    email: '',
    address: 'KARTALTEPE MAH CİCOZ YOLU CAD SÜMBÜL SOKAK NO52A BAYRAMPAŞA, Istanbul, Turkey 34400',
    workingHours: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi: 09:00 - 14:00',
    serviceAreas: DEFAULT_SERVICE_AREAS
  });
  const [newServiceArea, setNewServiceArea] = useState('');

  // Basit şifre kontrolü
  const ADMIN_PASSWORD = 'kalfa.2026!';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setPassword('');
    } else {
      alert('Yanlış şifre!');
    }
  };

  // imgbb API ile resim yükleme fonksiyonu
  const uploadImageToImgbb = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const base64 = reader.result.split(',')[1];
        const formData = new FormData();
        formData.append('key', IMGBB_API_KEY);
        formData.append('image', base64);

        try {
          const response = await fetch('https://api.imgbb.com/1/upload', {
            method: 'POST',
            body: formData
          });
          const data = await response.json();
          if (data.success && data.data && data.data.url) {
            resolve(data.data.url);
          } else {
            reject(new Error(data.error?.message || data.status_txt || 'Resim yüklenemedi'));
          }
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
    });
  };

  // Realtime Database'den veri dinle
  useEffect(() => {
    if (!isAuthenticated) return;

    // Ürünleri dinle
    const productsRef = ref(database, 'products');
    const unsubscribeProducts = onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const productsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setProducts(productsList);
      } else {
        setProducts([]);
      }
    });

    // Hizmetleri dinle
    const servicesRef = ref(database, 'services');
    const unsubscribeServices = onValue(servicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const servicesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setServices(servicesList);
      } else {
        setServices([]);
      }
    });

    // Müşteri yorumlarını dinle
    const testimonialsRef = ref(database, 'testimonials');
    const unsubscribeTestimonials = onValue(testimonialsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const testimonialsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setTestimonials(testimonialsList);
      } else {
        setTestimonials([]);
      }
    });

    // İletişim bilgilerini yükle
    const contactRef = ref(database, 'contactInfo');
    const unsubscribeContact = onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setContactInfo({
          ...data,
          serviceAreas: Array.isArray(data.serviceAreas) && data.serviceAreas.length > 0 ? data.serviceAreas : DEFAULT_SERVICE_AREAS
        });
      }
    });

    return () => {
      unsubscribeProducts();
      unsubscribeServices();
      unsubscribeTestimonials();
      unsubscribeContact();
    };
  }, [isAuthenticated]);

  // Ürün ekle
  const handleAddProduct = async (e) => {
    e.preventDefault();
    if (newProduct.title && newProduct.description) {
      setUploadingProduct(true);
      try {
        let imageUrl = null;
        if (newProduct.image) {
          imageUrl = await uploadImageToImgbb(newProduct.image);
        }
        
        const productsRef = ref(database, 'products');
        await push(productsRef, {
          title: newProduct.title,
          description: newProduct.description,
          image: imageUrl,
          createdAt: new Date().toISOString()
        });
        setNewProduct({ title: '', description: '', image: null });
        alert('Ürün başarıyla eklendi!');
      } catch (error) {
        console.error('Resim yükleme hatası:', error);
        alert('Resim yüklenirken hata oluştu: ' + error.message);
      } finally {
        setUploadingProduct(false);
      }
    }
  };

  // Mock hizmetler
  const MOCK_SERVICES = [
    { title: 'Kettle satışı', description: 'Su ısıtıcı (kettle) satışı. Farklı kapasite ve marka seçenekleri; hızlı teslimat ve uygun fiyat garantisi.' },
    { title: 'Kettle tamiri', description: 'Su ısıtıcınız çalışmıyorsa veya sızıntı yapıyorsa arıza tespiti ve tamiri yapıyoruz. Aynı gün müdahale imkânı.' },
    { title: 'Elektrikli çaycı satışı', description: 'Elektrikli çaycı satışı. Demleme süresi ayarlı, güvenli ve uzun ömürlü modeller; ev ve iş yeri için uygun seçenekler.' },
    { title: 'Elektrikli çaycı tamiri', description: 'Elektrikli çaycı arızalarında profesyonel tamir. Isıtma, zamanlama ve sızıntı sorunları giderilir.' },
    { title: 'Mini fırın satışı', description: 'Mini fırın (fritöz, turbo fırın) satışı. Küçük mutfaklar ve tek kişilik kullanım için ideal, enerji tasarruflu modeller.' },
    { title: 'Mini fırın tamiri', description: 'Mini fırın ısınmıyor, fan çalışmıyor veya kapak kapanmıyorsa arıza tespiti ve tamiri yapıyoruz.' },
    { title: 'Tost makinesi satışı', description: 'Tost makinesi satışı. Tek dilim, çift dilim ve sandviç modelleri; güvenli kullanım ve kolay temizlik.' },
    { title: 'Tost makinesi tamiri', description: 'Tost makinesi ısınmıyor veya sıkışıyorsa tamir ediyoruz. Isıtıcı ve mekanik arızalar giderilir.' },
    { title: 'Ütü satışı', description: 'Buharlı ve kuru ütü satışı. Farklı güç ve özelliklerde modeller; uzun ömürlü kullanım için kaliteli seçenekler.' },
    { title: 'Ütü tamiri', description: 'Ütü ısınmıyor, buhar çıkmıyor veya su sızıntısı varsa arıza tespiti ve tamiri; hızlı teslim.' },
    { title: 'Elektrik süpürgesi satışı', description: 'Elektrik süpürgesi satışı. Torbalı, torbasız ve robot süpürge seçenekleri; filtre ve aksesuar desteği.' },
    { title: 'Elektrik süpürgesi tamiri', description: 'Süpürge çekmiyor, motor sesi anormal veya şarj olmuyorsa tamir ediyoruz. Motor ve hortum arızaları giderilir.' },
    { title: 'Ampul satışı', description: 'LED, tasarruf ve akıllı ampul satışı. E27, E14, GU10 vb. duy tipleri; farklı watt ve renk sıcaklığı seçenekleri.' },
    { title: 'Priz satışı', description: 'Priz ve anahtar satışı. Tekli, çoklu, USB’li ve çocuk korumalı modeller; montaj desteği sunuyoruz.' },
    { title: 'Anahtar (elektrik düğmesi) satışı', description: 'Elektrik anahtarı (düğme) satışı. Tekli, çiftli ve dimmer modeller; mevcut tesisata uyumlu seçenekler.' },
    { title: 'Uzatma kablosu satışı', description: 'Uzatma kablosu ve çoklu priz satışı. Farklı metre ve priz sayıları; aşırı yük korumalı modeller.' },
    { title: 'Elektrik arıza tespiti', description: 'Ev ve iş yerinizde elektrik arızası tespiti. Sigorta atması, kısa devre ve topraklama kontrolleri yapıyoruz.' },
    { title: 'Elektrik arıza giderimi', description: 'Tespit edilen elektrik arızalarının giderimi. Priz, anahtar, tesisat ve pano düzenlemeleri; güvenli ve standartlara uygun işçilik.' },
    { title: 'Kapı kilit değişimi', description: 'Kapı kilidi değişimi ve yeni kilit takılması. Silindir, asma kilit ve manyetik kilit seçenekleri; hızlı ve güvenli montaj.' },
    { title: 'Kapı kilit tamiri', description: 'Kapı kilidi sıkışıyor, anahtar dönmüyor veya dil atlamıyorsa tamir ediyoruz. Yağlama, ayar ve parça değişimi.' },
    { title: 'Kepenk kumanda alıcı değişimi', description: 'Kepenk kumanda alıcısı (modül) değişimi. Eski kumandayla uyumlu veya yeni frekanslı alıcı takılıyor; açılır kapanır sorun giderilir.' },
    { title: 'Kepenk kumanda tamiri', description: 'Kepenk kumandası çalışmıyor veya motor yanıt vermiyorsa arıza tespiti ve tamiri. Pil, frekans ve motor kontrolü.' },
    { title: 'Kumanda çoğaltma', description: 'TV, klima, kepenk ve diğer cihazlar için kumanda çoğaltma. Orijinale uyumlu, hızlı teslimat.' },
    { title: 'Kumanda pil değişimi', description: 'Kumanda pili değişimi. Doğru pil tipi ve montaj; uzun ömürlü kullanım için kaliteli pil kullanıyoruz.' },
    { title: 'Anahtar çoğaltma', description: 'Eviniz, iş yeriniz veya araç anahtarlarınızın kopyasını çıkarıyoruz. Çipli ve çipsiz anahtar seçenekleri; hızlı teslim.' }
  ];

  const handleLoadMockServices = async () => {
    if (!window.confirm('Firebase\'e ' + MOCK_SERVICES.length + ' adet örnek hizmet eklenecek. Devam edilsin mi?')) return;
    const servicesRef = ref(database, 'services');
    for (const s of MOCK_SERVICES) {
      await push(servicesRef, {
        title: s.title,
        description: s.description,
        createdAt: new Date().toISOString()
      });
    }
    alert('Mock hizmetler başarıyla eklendi!');
  };

  // Hizmet ekle
  const handleAddService = async (e) => {
    e.preventDefault();
    if (newService.title && newService.description) {
      setUploadingService(true);
      try {
        let imageUrl = null;
        if (newService.image) {
          imageUrl = await uploadImageToImgbb(newService.image);
        }
        const servicesRef = ref(database, 'services');
        await push(servicesRef, {
          title: newService.title,
          description: newService.description,
          image: imageUrl,
          createdAt: new Date().toISOString()
        });
        setNewService({ title: '', description: '', image: null });
        alert('Hizmet başarıyla eklendi!');
      } catch (error) {
        console.error('Resim yükleme hatası:', error);
        alert('Resim yüklenirken hata oluştu: ' + error.message);
      } finally {
        setUploadingService(false);
      }
    }
  };

  // Hizmete fotoğraf ekle/güncelle
  const handleServiceImageUpload = async (serviceId, file) => {
    if (!file || !serviceId) return;
    const service = services.find((s) => s.id === serviceId);
    if (!service) return;
    try {
      const imageUrl = await uploadImageToImgbb(file);
      const serviceRef = ref(database, `services/${serviceId}`);
      await set(serviceRef, {
        ...service,
        image: imageUrl,
        title: service.title,
        description: service.description,
        createdAt: service.createdAt || new Date().toISOString()
      });
      alert('Fotoğraf eklendi!');
    } catch (error) {
      console.error('Resim yükleme hatası:', error);
      alert('Resim yüklenirken hata oluştu: ' + error.message);
    }
  };

  // Ürün sil
  const handleDeleteProduct = async (id) => {
    if (window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) {
      const productRef = ref(database, `products/${id}`);
      await remove(productRef);
    }
  };

  // Hizmet sil
  const handleDeleteService = async (id) => {
    if (window.confirm('Bu hizmeti silmek istediğinize emin misiniz?')) {
      const serviceRef = ref(database, `services/${id}`);
      await remove(serviceRef);
    }
  };

  // Mock müşteri yorumları
  const MOCK_TESTIMONIALS = [
    { name: 'Ahmet Yılmaz', company: 'Konut', comment: 'Tost makinesi ve TV tamirini aynı gün yaptılar. Çok memnun kaldım, fiyatlar da uygun.', rating: 5 },
    { name: 'Ayşe Kaya', company: 'Ev Sahibi', comment: 'Buzdolabı tamiri için geldiler, çok hızlı ve titiz çalıştılar. Kesinlikle tavsiye ederim.', rating: 5 },
    { name: 'Mehmet Demir', company: 'Kafe Sahibi', comment: 'İşyerimizin elektrik tesisatını ve klima bakımını yaptılar. Profesyonel ekip.', rating: 5 },
    { name: 'Fatma Öz', company: '-', comment: 'Çamaşır makinesi tamiri çok uygun fiyata yapıldı. Teşekkürler Kalfa Elektrik.', rating: 4 },
    { name: 'Ali Çelik', company: 'Ofis', comment: 'Aydınlatma ve priz sorunlarını tek seferde çözdüler. 7/24 destek verdiler.', rating: 5 },
    { name: 'Zeynep Arslan', company: 'Ev Sahibi', comment: 'Klima montajı ve elektrik işleri için çağırdım. Temiz ve düzgün iş çıkardılar.', rating: 5 },
    { name: 'Mustafa Şahin', company: 'Dükkan Sahibi', comment: 'Beyaz eşya tamirinde çok deneyimliler. Fiyat performans çok iyi.', rating: 4 },
    { name: 'Elif Yıldız', company: '-', comment: 'Küçük ev aletleri tamiri yaptırdım. Hızlı ve güvenilir hizmet.', rating: 5 },
    { name: 'Hasan Aydın', company: 'Restoran', comment: 'Endüstriyel mutfak ekipmanları ve elektrik işlerinde tek adres. Teşekkürler.', rating: 5 },
    { name: 'Seda Koç', company: 'Ev Sahibi', comment: 'Sigorta sürekli atıyordu, panoyu yenilediler. Artık hiç sorun yok. Çok teşekkürler.', rating: 5 }
  ];

  const handleLoadMockTestimonials = async () => {
    if (!window.confirm('Firebase\'e ' + MOCK_TESTIMONIALS.length + ' adet örnek müşteri yorumu eklenecek. Devam edilsin mi?')) return;
    const testimonialsRef = ref(database, 'testimonials');
    for (const t of MOCK_TESTIMONIALS) {
      await push(testimonialsRef, {
        name: t.name,
        company: t.company || '',
        comment: t.comment,
        rating: t.rating || 5,
        createdAt: new Date().toISOString()
      });
    }
    alert('Mock müşteri yorumları başarıyla eklendi!');
  };

  // Müşteri yorumu ekle
  const handleAddTestimonial = async (e) => {
    e.preventDefault();
    if (newTestimonial.name && newTestimonial.comment) {
      const testimonialsRef = ref(database, 'testimonials');
      await push(testimonialsRef, {
        name: newTestimonial.name,
        company: newTestimonial.company || '',
        comment: newTestimonial.comment,
        rating: newTestimonial.rating || 5,
        createdAt: new Date().toISOString()
      });
      setNewTestimonial({ name: '', company: '', comment: '', rating: 5 });
      alert('Müşteri yorumu başarıyla eklendi!');
    }
  };

  // Müşteri yorumu sil
  const handleDeleteTestimonial = async (id) => {
    if (window.confirm('Bu yorumu silmek istediğinize emin misiniz?')) {
      const testimonialRef = ref(database, `testimonials/${id}`);
      await remove(testimonialRef);
    }
  };

  // İletişim bilgilerini kaydet
  const handleSaveContactInfo = async (e) => {
    e.preventDefault();
    const contactRef = ref(database, 'contactInfo');
    await set(contactRef, contactInfo);
    alert('İletişim bilgileri kaydedildi!');
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-box">
          <h2>Admin Girişi</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Giriş Yap</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Admin Panel</h1>
        <button onClick={() => setIsAuthenticated(false)} className="logout-btn">
          Çıkış Yap
        </button>
      </div>

      <div className="admin-tabs">
        <button
          className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => setActiveTab('products')}
        >
          Ürünler
        </button>
        <button
          className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => setActiveTab('services')}
        >
          Hizmetler
        </button>
        <button
          className={`tab-button ${activeTab === 'testimonials' ? 'active' : ''}`}
          onClick={() => setActiveTab('testimonials')}
        >
          Müşteri Yorumları
        </button>
        <button
          className={`tab-button ${activeTab === 'contact' ? 'active' : ''}`}
          onClick={() => setActiveTab('contact')}
        >
          İletişim Bilgileri
        </button>
      </div>

      <div className="admin-content">
        {/* Ürünler Sekmesi */}
        {activeTab === 'products' && (
          <div className="admin-section">
            <h2>Ürünler</h2>
            <form onSubmit={handleAddProduct} className="admin-form">
              <input
                type="text"
                placeholder="Ürün Başlığı"
                value={newProduct.title}
                onChange={(e) => setNewProduct({ ...newProduct, title: e.target.value })}
                required
              />
              <textarea
                placeholder="Ürün Açıklaması"
                value={newProduct.description}
                onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
                required
              />
              <div className="file-input-wrapper">
                <label className="file-label">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setNewProduct({ ...newProduct, image: e.target.files[0] })}
                    className="file-input"
                  />
                  <span className="file-button">
                    {newProduct.image ? newProduct.image.name : 'Resim Seç (Opsiyonel)'}
                  </span>
                </label>
                {newProduct.image && (
                  <button
                    type="button"
                    onClick={() => setNewProduct({ ...newProduct, image: null })}
                    className="remove-file-btn"
                  >
                    ✕
                  </button>
                )}
              </div>
              <button type="submit" disabled={uploadingProduct}>
                {uploadingProduct ? 'Yükleniyor...' : 'Ürün Ekle'}
              </button>
            </form>

            <div className="items-list items-list-grid">
              {products.length === 0 ? (
                <p className="empty-message">Henüz ürün eklenmemiş.</p>
              ) : (
                products.map((product) => (
                  <div key={product.id} className="item-card">
                    {product.image && (
                      <img src={product.image} alt={product.title} className="item-image" />
                    )}
                    <h3>{product.title}</h3>
                    <p>{product.description}</p>
                    <button
                      onClick={() => handleDeleteProduct(product.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Hizmetler Sekmesi */}
        {activeTab === 'services' && (
          <div className="admin-section">
            <h2>Hizmetler</h2>
            <button type="button" onClick={handleLoadMockServices} className="mock-data-btn">
              Mock Hizmetler Ekle (Örnek: Tost makinesi, TV, buzdolabı tamiri vb.)
            </button>
            <form onSubmit={handleAddService} className="admin-form">
              <input
                type="text"
                placeholder="Hizmet Başlığı"
                value={newService.title}
                onChange={(e) => setNewService({ ...newService, title: e.target.value })}
                required
              />
              <textarea
                placeholder="Hizmet Açıklaması"
                value={newService.description}
                onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                required
              />
              <div className="form-image-upload">
                <label>Hizmet fotoğrafı (opsiyonel):</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setNewService({ ...newService, image: e.target.files[0] || null })}
                />
                {newService.image && <span className="image-name">{newService.image.name}</span>}
              </div>
              <button type="submit" disabled={uploadingService}>
                {uploadingService ? 'Yükleniyor...' : 'Hizmet Ekle'}
              </button>
            </form>

            <div className="items-list">
              {services.length === 0 ? (
                <p className="empty-message">Henüz hizmet eklenmemiş.</p>
              ) : (
                services.map((service) => (
                  <div key={service.id} className="item-card">
                    {service.image && (
                      <div className="item-card-image-wrap">
                        <img src={service.image} alt={service.title} className="item-card-image" />
                      </div>
                    )}
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="item-card-actions">
                      <label className="upload-photo-btn">
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) handleServiceImageUpload(service.id, file);
                            e.target.value = '';
                          }}
                        />
                        {service.image ? 'Fotoğrafı Değiştir' : 'Fotoğraf Ekle'}
                      </label>
                      <button
                        onClick={() => handleDeleteService(service.id)}
                        className="delete-btn"
                      >
                        Sil
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* Müşteri Yorumları Sekmesi */}
        {activeTab === 'testimonials' && (
          <div className="admin-section">
            <h2>Müşteri Yorumları</h2>
            <button type="button" onClick={handleLoadMockTestimonials} className="mock-data-btn">
              Mock Yorumlar Ekle (Örnek müşteri yorumları)
            </button>
            <form onSubmit={handleAddTestimonial} className="admin-form">
              <input
                type="text"
                placeholder="Müşteri Adı"
                value={newTestimonial.name}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, name: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder="Şirket Adı (Opsiyonel)"
                value={newTestimonial.company}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, company: e.target.value })}
              />
              <textarea
                placeholder="Yorum"
                value={newTestimonial.comment}
                onChange={(e) => setNewTestimonial({ ...newTestimonial, comment: e.target.value })}
                required
                rows="5"
              />
              <div className="rating-input">
                <label>Değerlendirme (Yıldız):</label>
                <select
                  value={newTestimonial.rating}
                  onChange={(e) => setNewTestimonial({ ...newTestimonial, rating: parseInt(e.target.value) })}
                >
                  <option value={5}>5 Yıldız</option>
                  <option value={4}>4 Yıldız</option>
                  <option value={3}>3 Yıldız</option>
                  <option value={2}>2 Yıldız</option>
                  <option value={1}>1 Yıldız</option>
                </select>
              </div>
              <button type="submit">Yorum Ekle</button>
            </form>

            <div className="items-list">
              {testimonials.length === 0 ? (
                <p className="empty-message">Henüz yorum eklenmemiş.</p>
              ) : (
                testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="item-card">
                    <h3>{testimonial.name}</h3>
                    {testimonial.company && <p style={{ color: '#6b7280', marginBottom: '0.5rem' }}>{testimonial.company}</p>}
                    <div style={{ marginBottom: '0.5rem', display: 'flex', gap: '2px' }}>
                      {Array.from({ length: 5 }, (_, i) => (
                        <span key={i} style={{ color: i < (testimonial.rating || 5) ? '#fbbf24' : '#d1d5db', display: 'inline-flex' }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
                        </span>
                      ))}
                      <span style={{ marginLeft: '0.5rem', color: '#6b7280' }}>({testimonial.rating || 5}/5)</span>
                    </div>
                    <p>{testimonial.comment}</p>
                    <button
                      onClick={() => handleDeleteTestimonial(testimonial.id)}
                      className="delete-btn"
                    >
                      Sil
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {/* İletişim Bilgileri Sekmesi */}
        {activeTab === 'contact' && (
          <div className="admin-section">
            <h2>İletişim Bilgileri</h2>
            <form onSubmit={handleSaveContactInfo} className="admin-form">
              <div className="form-group">
                <label>Telefon</label>
                <input
                  type="text"
                  value={contactInfo.phone}
                  onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>E-posta</label>
                <input
                  type="email"
                  value={contactInfo.email}
                  onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Adres</label>
                <textarea
                  value={contactInfo.address}
                  onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
                  required
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Çalışma Saatleri</label>
                <textarea
                  value={contactInfo.workingHours}
                  onChange={(e) => setContactInfo({ ...contactInfo, workingHours: e.target.value })}
                  required
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Hizmet Bölgeleri</label>
                <p className="form-hint">Hizmet verdiğiniz semt/mahalleleri ekleyin veya silin. Sitede &quot;Hizmet verdiğimiz semtler&quot; olarak gösterilir.</p>
                <button
                  type="button"
                  className="mock-areas-btn"
                  onClick={() => setContactInfo({ ...contactInfo, serviceAreas: [...DEFAULT_SERVICE_AREAS] })}
                >
                  Varsayılan 4 Bölgeyi Ekle (Yıldırım, Kocatepe, Kartaltepe, Muratpaşa Mah)
                </button>
                <div className="service-areas-edit">
                  <div className="service-areas-list">
                    {(contactInfo.serviceAreas || []).map((area, index) => (
                      <div key={`${area}-${index}`} className="service-area-chip">
                        <span>{area}</span>
                        <button
                          type="button"
                          className="service-area-remove"
                          onClick={() => {
                            const next = (contactInfo.serviceAreas || []).filter((_, i) => i !== index);
                            setContactInfo({ ...contactInfo, serviceAreas: next });
                          }}
                          aria-label="Kaldır"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="service-area-add">
                    <input
                      type="text"
                      placeholder="Yeni bölge (örn: Örnek Mah)"
                      value={newServiceArea}
                      onChange={(e) => setNewServiceArea(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          if (newServiceArea.trim()) {
                            setContactInfo({ ...contactInfo, serviceAreas: [...(contactInfo.serviceAreas || []), newServiceArea.trim()] });
                            setNewServiceArea('');
                          }
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="add-area-btn"
                      onClick={() => {
                        if (newServiceArea.trim()) {
                          setContactInfo({ ...contactInfo, serviceAreas: [...(contactInfo.serviceAreas || []), newServiceArea.trim()] });
                          setNewServiceArea('');
                        }
                      }}
                    >
                      Bölge Ekle
                    </button>
                  </div>
                </div>
              </div>

              <button type="submit" className="save-btn">Kaydet</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
